// Desktop/web must not import the mobile review module or its native dependencies.
export default function MobileReviewHost() { return null; }
